import { axios } from '@/utils/request'
import ipConfig from '@../../../config/ip.config'

export const getDomesticTradePageList = (query) => axios({
  url: ipConfig.api_edi + `/api/DomesticTrade/GetDomesticTradePageList`,
  method: 'get',
  params: query
})

export const getDataStatistics = (query) => axios({
  url: ipConfig.api_edi + `/api/DomesticTrade/GetDataStatistics`,
  method: 'get',
  params: query
})

export const getBusinessStatisticsTotal = (query) => axios({
  url: ipConfig.api_edi + `/api/DomesticTrade/GetBusinessStatisticsTotal`,
  method: 'get',
  params: query
})

export const getTEUStatisticsTotal = (query) => axios({
  url: ipConfig.api_edi + `/api/DomesticTrade/GetTEUStatisticsTotal`,
  method: 'get',
  params: query
})

export const getMMFileListByBookingNo = (query) => axios({
  url: ipConfig.api_edi + `/api/DomesticTrade/GetFileListByBookingNo`,
  method: 'get',
  params: query
})
